module.exports = __webpack_public_path__ + "b26af4c101ccfdc230d3c6436249c0f4.woff";


/*****************
 ** WEBPACK FOOTER
 ** ./src/styles/fonts/Simple-Line-Icons/Simple-Line-Icons.woff
 ** module id = ./src/styles/fonts/Simple-Line-Icons/Simple-Line-Icons.woff
 ** module chunks = 0
 **/